(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product-recommendations"]) return;
  try {
    
  const recommendationSections = new WeakSet();

  const syncRecommendationHeight = (container) => {
    const row = container.querySelector('[data-product-row]');
    const viewport = container.querySelector('.flickity-viewport');
    const slider = container.querySelector('.flickity-slider');

    if (!row || !viewport || !slider) return;

    if (!window.matchMedia('(max-width: 1023px)').matches) {
      row.style.removeProperty('height');
      viewport.style.removeProperty('height');
      return;
    }

    const height = Math.ceil(slider.getBoundingClientRect().height);

    if (height > 0) {
      row.style.height = `${height}px`;
      viewport.style.height = `${height}px`;
    }
  };

  const watchRecommendationSection = (container) => {
    const slider = container.querySelector('.flickity-slider');

    if (!slider || recommendationSections.has(slider)) return;

    recommendationSections.add(slider);
    const resizeObserver = new ResizeObserver(() => syncRecommendationHeight(container));
    resizeObserver.observe(slider);
    syncRecommendationHeight(container);
  };

  const refreshRecommendationSections = () => {
    document.querySelectorAll('.product-recommendations--container').forEach(watchRecommendationSection);
  };

  const recommendationObserver = new MutationObserver(refreshRecommendationSections);
  recommendationObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', refreshRecommendationSections);
  document.addEventListener('shopify:section:load', refreshRecommendationSections);
  refreshRecommendationSections();

  } catch(e) { console.error(e); }
})();
})();
